import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './HTEWidget.scss';

const HTEWidget = ({ sectionData }) => {
  const isDataPresent =
    sectionData &&
    Array.isArray(sectionData.items) &&
    sectionData.items.length > 0;

  if (!isDataPresent) {
    return null;
  }

  const { items, name } = sectionData;

  return (
    <div className={s.HTEhighlight}>
      <h2>{name}</h2>
      <ul>
        {items.map((item, index) => (
          <li key={index}>
            <Link to={item.wu} index={index}>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

HTEWidget.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        wu: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }),
    ),
  }),
};

HTEWidget.defaultProps = {
  sectionData: {
    name: '',
    items: [],
  },
};

export default HTEWidget;
